<template>
  <div v-if="defaultValue" class="side-wp" :class="{close: isClose}">
    <div v-if="isWap && !isClose" class="mask-wp" @click="closeSide"></div>
    <resize-panel
      class="sidebar"
      :maxWidthRateOfWindow=".25"
      :minWidth="150"
      :resizeSide="'right'"
      @sizeChange="sizeChange"
    >
      <div class="menu-wp">
        <t-menu theme="light" height="550px" width="100%" :defaultExpanded="defaultExpanded" :defaultValue="defaultValue" class="menu-bd">
          <template v-for="(menu, index) in categoryInfo">
            <!-- 一级目录 -->
            <t-menu-item
              v-if="!menu.has_children"
              :value="menu.id"
              :key="index"
              @click="openMenu(menu)"
              :class="{ hide: isMenuHide(menu.title) }"
            >
              {{ menu.title }}
            </t-menu-item>

            <t-submenu
              v-else
              :key="index"
              :title="menu.title"
              :value="menu.id"
              :class="{ hide: isMenuHide(menu.title) }"
            >
              <template v-for="(subMenu, subIndex) in menu.childrens">
                <!-- 二级目录 -->
                <t-menu-item
                  v-if="!subMenu.has_children"
                  :value="subMenu.id"
                  :key="subIndex"
                  :class="{ hide: isMenuHide(subMenu.title) }"
                  @click="openMenu(subMenu)"
                >
                  {{ subMenu.title }}
                </t-menu-item>

                <!-- 三级目录 -->
                <t-submenu
                  v-else
                  :key="subIndex"
                  :title="subMenu.title"
                  :value="subMenu.id"
                  :class="{ hide: isMenuHide(subMenu.title) }"
                >
                  <t-menu-item
                    v-for="(thirdMenu, thirdIndex) in subMenu.childrens"
                    :key="thirdIndex"
                    :title="thirdMenu.title"
                    :value="thirdMenu.id"
                    @click="openMenu(thirdMenu)"
                  >
                    {{ thirdMenu.title }}
                  </t-menu-item>
                </t-submenu>
              </template>
            </t-submenu>
          </template>
        </t-menu>
        <div v-if="isWap" class="btn-close" @click="closeSide"><t-icon name="arrow-left" size="30"/></div>
      </div>
    </resize-panel>
    <div v-if="isWap && isClose" class="btn-scale" @click="openSide"><t-icon name="view-module" size="30"/></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ResizePanel from '@/components/resize-panel';

export default {
  name: 'letSideNav',
  components: {
    ResizePanel
  },
  props: {
    defaultExpanded: {
      type: Array,
      default: [],
    },
    defaultValue: {
      type: Number,
      default: 0,
    },
  },
  inject: ['getIsWap'],
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapState('doc', ['categoryInfo']),
    isWap() {
      return this.getIsWap();
    },
    isClose() {
      return this.isWap && !this.isOpen;
    },
  },
  methods: {
    openMenu(menu) {
      this.closeSide();
      this.$emit('openMenu', menu);
    },
    isMenuHide(menu) {
      // 标题含有测试的目录要过滤掉
      return menu.indexOf('(测试)') >= 0;
    },
    sizeChange({sideWidth}) {
      document.documentElement.style.setProperty('--left-side-width', `${sideWidth}px`);
    },
    openSide() {
      this.isOpen = true;
    },
    closeSide() {
      this.isOpen = false;
    },
  },
};
</script>
<style scoped>
.side-nav {
  position: fixed;
  top: 60px;
  right: 0;
  z-index: 10;
  background-color: #fff;
  height: calc(100vh - 60px);
  transition: transform 0.3s;
}
.side-nav.close {
  transform: translateX(var(--right-side-width));
}
.side-nav .side-txt {
  font-size: 16px;
  font-weight: 700;
  color: #202328;
  line-height: 40px;
  padding-left: 20px;
}
.side-cont {
  padding: 0 14px;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: calc(100vh - 100px);
}
.side-nav .close-box {
  position: absolute;
  top: 50%;
  width: 20px;
  height: 80px;
  background-color: #e5e7e9;
  left: -20px;
  margin-top: -40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
}
.side-nav:hover .close-box,
.side-nav.close .close-box {
  opacity: 1;
  pointer-events: initial;
}
.side-nav .close-box::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent #e5e7e9 #e5e7e9 transparent;
}
.side-nav .close-box::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: #e5e7e9 #e5e7e9 transparent transparent;
}
.side-nav .btn-resize {
  position: absolute;
  left: -3px;
  top: 0;
  width: 8px;
  height: 100%;
  cursor: ew-resize;
}
.sidebar {
  transition: transform .2s;
}
.side-wp.close .sidebar {
  transform: translateX(-100%);
}
.menu-wp {
  height: 100%;
  position: relative;
  overflow: hidden;
}
.menu-wp .btn-close {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.menu-bd {
  overflow-y: scroll;
}
.btn-scale {
  position: fixed;
  z-index: 15;
  width: 30px;
  height: 30px;
  top: 65px;
  left: 5px;
  font-size: 0;
}
.mask-wp {
  position: fixed;
  z-index: 99;
  top: 60px;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);
  height: calc(100vh - 60px);
}
</style>
